import Vue from 'vue'
import { DisabledIconFocus, InputMask, LimitLinefeed } from '@/directives'

Vue.directive('input-mask', InputMask)
Vue.directive('limit-linefeed', LimitLinefeed)
Vue.directive('disabled-icon-focus', DisabledIconFocus)
